import type { SubscriptionResponse } from "@/services/api_types";
import { bewaarBetaling } from "./betaalRecord";
import type { Platform } from "@/hooks/useLayoutMode";
import type { Surface } from "./surface";

// Persist before POST. A network error or reload must reuse the same purchase.
export async function lifetimeCheckoutIntent(
  scope: string,
  platform: Platform,
  surface: Surface | null
) {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(scope)
  );
  const key = `wiswiz_lifetime_intent_${Array.from(new Uint8Array(digest), (v) => v.toString(16).padStart(2, "0")).join("")}`;
  const existing = window.localStorage.getItem(key);
  if (existing)
    return JSON.parse(existing) as {
      requestId: string;
      platform: Platform;
      surface: Surface | null;
    };
  const intent = { requestId: crypto.randomUUID(), platform, surface };
  const saved = JSON.stringify(intent);
  window.localStorage.setItem(key, saved);
  if (window.localStorage.getItem(key) !== saved)
    throw new Error("Purchase identity could not be saved");
  return intent;
}

export function lifetimePurchaseUrl(subscriptionId: string): string {
  return `/account/betaling/${encodeURIComponent(subscriptionId)}`;
}

export function rememberLifetimeCheckout(result: SubscriptionResponse): void {
  if (!result.subscription_id || !result.purchase_id) return;
  bewaarBetaling({
    id: result.payment_id ?? null,
    ts: Date.now(),
    plan_id: "lifetime",
    terug: lifetimePurchaseUrl(result.subscription_id),
    subscription_id: result.subscription_id,
    purchase_id: result.purchase_id
  });
}
